(function () {
    const initFeedbackSlider = () => {
      const oSliderWithText = document.querySelectorAll('.sus_slider_with_text-swiper');
      oSliderWithText.forEach((slider, index) => {
        const oSliderWithTextElement = new Swiper(slider, {
          slidesPerView: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          simulateTouch: true,
          autoHeight: true,
          speed: 500,
          loop: true,
          freeMode: true,
          threshold: 0,
          navigation: {
            nextEl: '.carousel__slider-nav .swiper-button-next',
            prevEl: '.carousel__slider-nav .swiper-button-prev',
          },
        });
      });
    };
    initFeedbackSlider();
  })();